export const PREVIEW_SIZE = 500
export const NOTIFICATION_CHECK_INTERVAL = 1 * 10 * 1000 // 通知をチェックする間隔
export const REVISION_CHECK_INTERVAL = 5 * 1000 // リビジョンをチェックする間隔
export const THUMBNAIL_SIZE = 163 // 編集画面の写真表示サイズ
export const IMAGE_SIZE_MIN = 100 // 読込最小画像サイズ
export const IMAGE_SIZE_MAX = 1280 // 読込最大画像サイズ
